<template>
  <div class="wrapper">
    <sidebar-fixed-toggle-button />
    <side-bar :background-color="backgroundColor" :sidebarLinks="itensMenu">
    </side-bar>
    <div class="main-panel" :data="backgroundColor">
      <top-navbar :permissoes="itensMenuTopBar"></top-navbar>

      <dashboard-content @click.native="toggleSidebar"></dashboard-content>

      <content-footer></content-footer>
    </div>
    <Carregando v-if="isLoading" />
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./DashboardContent.vue";
import SideBar from "@/components/SidebarPlugin/SideBar.vue";
import SidebarLink from "@/components/SidebarPlugin/SidebarLink.vue";
import SidebarFixedToggleButton from "./SidebarFixedToggleButton.vue";
import globalVariable from '../../globalVariable';
import Carregando from "../../../src/pages/Loads/Carregando.vue";
import swal from "sweetalert2";


export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    SideBar,
    SidebarLink,
    // SidebarShare,
    SidebarFixedToggleButton,
    Carregando
  },
  data() {
    return {
      backgroundColor: "green",
      itensMenu: [],
      itensMenuTopBar: [],
      isLoading: false,
      permissoes: []
    };
  },
  created() {
    const isUsuario = this.$cookies.get("usuario");

    if (isUsuario) {
      this.listarMenuUsuario();
    } else {
      this.listarMenuAdmin();
    }
  },
  computed: {
    isRTL() {
      return this.$rtl.isRTL;
    },
  },
  methods: {
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    async carregarPermissoes() {
      const dados = this.$cookies.get("usuario");

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: dados.idPerfil
      };

      const th = this;

      await this.axios
        .post("/api/usuarios/listarPerfilPorId", bodyFormData)
        .then((response) => {
          th.isLoading = false;
          if (response.data.status == "success" && response.data.data.length) {

            th.permissoes = response.data.data[0].funcionalidades;
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao carregar Permissões!",
              "error"
            );
          }
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao tentar carregar Permissões!",
            "error"
          );
          // warning, error, success, info, and question
        });
    },
    listarMenuAdmin() {

      for (let item of globalVariable.menu) {

        if (item.children && item.children.length > 0) {
          const submenus = [];
          for (const sub of item.children) {
            submenus.push({
              name: this.$t(sub.name),
              path: sub.path
            });
          }

          item.children = submenus;
        }

        item = { ...item, name: this.$t(item.name) };

        this.itensMenu.push(item);
      }

    },
    async listarMenuUsuario() {

      await this.carregarPermissoes();
      const payload = this.permissoes;
      const menus = [];

      this.itensMenuTopBar = this.permissoes.filter(pr => pr.path === "/atualizarEmpresa" || pr.path === "/postosTrabalho")

      //tratando os pais
      for (let pai of globalVariable.menu) {

        const dataPai = payload.find(p => p.path === pai.path && p.status === "true" && !pai.children);
        if (dataPai) {
          const item = { ...pai, name: this.$t(pai.name) };
          menus.push(item)
        } else {
          // tratando os filhos
          if (pai.children) {

            const filhos = [];

            for (const filho of pai.children) {
              // procura nos filhos
              const dataFilho = payload.find(p => p.path === filho.path && p.status === "true");
              if (dataFilho) {
                const item = { ...filho, name: this.$t(filho.name) };
                filhos.push(item)
              }
            }

            if (filhos.length) {
              const menu = { ...pai, name: this.$t(pai.name), children: filhos };
              menus.push(menu);
            }

          }

        }
      }
      this.itensMenu = menus;
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
